import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const BatteryLevel = ({ t, value, isIcon }) => {
  const valueNumber = Number(value);

  return (
    <>
      {isIcon ? (
        <>{valueNumber > 79 ? <CroplerIcon name="batteryFull" /> : valueNumber > 20 ? <CroplerIcon name="batteryMiddle" /> : <CroplerIcon name="batteryEmpty" />}</>
      ) : (
        <>
          {value !== null ? (
            <>
              <div
                className={styles.batteryLevel}
                style={{
                  color: valueNumber > 79 ? 'var(--success)' : valueNumber > 20 ? 'var(--info)' : 'var(--error)',
                }}
              ></div>
              {value}%
            </>
          ) : (
            <span className={'text-muted'}>{t('empty.noData')}</span>
          )}
        </>
      )}
    </>
  );
};

export default BatteryLevel;
